import {Component} from '@angular/core';

@Component({
  selector: 'app-clock-icon',
  styles: `
    :host {
      height: 30px;
      width: 30px;
      display: inline-block;
      line-height: 0;
    }
  `,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
      <g clip-path="url(#clip0_2737_830)">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M15 0.9375C7.23844 0.9375 0.9375 7.23844 0.9375 15C0.9375 22.7616 7.23844 29.0625 15 29.0625C22.7616 29.0625 29.0625 22.7616 29.0625 15C29.0625 7.23844 22.7616 0.9375 15 0.9375ZM15 2.8125C21.7266 2.8125 27.1875 8.27344 27.1875 15C27.1875 21.7266 21.7266 27.1875 15 27.1875C8.27344 27.1875 2.8125 21.7266 2.8125 15C2.8125 8.27344 8.27344 2.8125 15 2.8125ZM14.0625 13.3762V6.5625C14.0625 6.045 14.4825 5.625 15 5.625C15.5175 5.625 15.9375 6.045 15.9375 6.5625V13.3762C16.4981 13.7006 16.875 14.3062 16.875 15C16.875 15.1678 16.8525 15.3309 16.8112 15.4856L21.2878 19.9622C21.6534 20.3278 21.6534 20.9222 21.2878 21.2878C20.9222 21.6534 20.3278 21.6534 19.9622 21.2878L15.4856 16.8112C15.3309 16.8525 15.1678 16.875 15 16.875C13.965 16.875 13.125 16.035 13.125 15C13.125 14.3062 13.5019 13.7006 14.0625 13.3762Z"
              fill="black"/>
      </g>
      <defs>
        <clipPath id="clip0_2737_830">
          <rect width="30" height="30" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `,
  standalone: true
})

export class ClockIconComponent {

}
